import { useState } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Tab } from 'react-bootstrap';

//Components
import withLocalization from '~/hoc/withLocalization';
import NotificationTemplates from '../NotificationTemplates/NotificationTemplates';
import NotificationMessages from './NotificationMessages';

const NotificationSettings = ({ t }) => {
    const [subTab, setSubTab] = useState('notification_templates');

    return (
        <Tab.Container activeKey={subTab} id="NotificationSettingsTabContainer" onSelect={() => { }}>
            <div className="custom-card">
                <Row>
                    <Col sm={3}>
                        <ul className="list-group">
                            <li
                                className={`list-group-item cursor-pointer${subTab === 'notification_templates' ? ' active' : ''}`}
                                onClick={() => setSubTab('notification_templates')}
                            >
                                {t('Notification')} {('Templates')}
                            </li>
                            <li
                                className={`list-group-item cursor-pointer${subTab === 'notification_messages' ? ' active' : ''}`}
                                onClick={() => setSubTab('notification_messages')}
                            >
                                {t('Notification')} {t('Messages')}
                            </li>
                        </ul>
                    </Col>
                    <Col sm={9}>
                        <Tab.Content>
                            <Tab.Pane eventKey="notification_templates" mountOnEnter>
                                <NotificationTemplates />
                            </Tab.Pane>
                            <Tab.Pane eventKey="notification_messages" mountOnEnter>
                                <NotificationMessages />
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </div>
        </Tab.Container>
    );
};

export default withLocalization(observer(NotificationSettings));
